// Shared by the row and the page's column header so the two can never drift apart. Columns, gap, and
// the left/right inline padding together determine cell alignment — changing any one of them on only
// one side would silently misalign the header labels against the row cells beneath them.
export const FEATURE_FLAG_GRID_COLUMNS = 'minmax(300px, 1fr) 160px 100px 90px 170px 220px 28px';
export const FEATURE_FLAG_LIST_MIN_WIDTH = '1320px';

/**
 * Extra breathing room on the left of the Created column. Users is right-aligned and Created is
 * left-aligned, so the two butt up against each other across the grid gap and the number reads as
 * part of the date. Applied as padding inside the column rather than as a wider gap, so only this
 * one boundary opens up; the column carries the inset on top of its content width. Both the row
 * cell and the header label use it — applying it to one side alone would misalign the two.
 */
export const FEATURE_FLAG_CREATED_COLUMN_INSET = '20px';
export const FEATURE_FLAG_GRID_GAP = '16px';
export const FEATURE_FLAG_GRID_PADDING_LEFT = '22px';
export const FEATURE_FLAG_GRID_PADDING_RIGHT = '18px';
